import React from 'react';
import PropTypes from 'prop-types';
import SignPadDialog from './SignPadDialog';
import SignOnMobilePopUp from './SignOnMobilePopUp';
import { ConfirmCollectBioData } from './ConfirmCollectBioData';
import SelectWayToSignPopUp, { WAYS_TO_SIGN } from './SelectWayToSignPopUp';
import { gae } from '../../helpers/Analytics';
import Uploader from '../../common/Uploader';
import { getBase64FromUrl } from '../../../lib/fileUtils';
import II18 from '../../translate/II18';

export default function withFormsCommonUI(WrappedComponent) {
  // noinspection JSPotentiallyInvalidUsageOfThis
  class withFormsCommonWrapper extends React.Component {
    state = {};

    onSignatureWaySelected = way => {
      gae('FORM_EDITOR', 'SIGNATURE_WAY_SELECTED', way);
      switch (way) {
        case WAYS_TO_SIGN.USE_CACHED_SIGNATURE:
          this.onReceiveSignature(this.props.cachedSignature);
          break;
        case WAYS_TO_SIGN.SIGN_ON_DESKTOP:
          this.setState({
            signTask: {
              wayToSign: WAYS_TO_SIGN.SIGN_ON_DESKTOP
            }
          });
          break;
        case WAYS_TO_SIGN.UPLOAD_SIGNATURE:
          this.uploadSignature();
          break;
        case WAYS_TO_SIGN.SIGN_ON_MOBILE:
          this.setState({
            signTask: {
              wayToSign: WAYS_TO_SIGN.SIGN_ON_MOBILE
            }
          });
          break;
        default:
        //no default
      }

      this.setState({ showSelectWayToSign: false });
    };

    uploadSignature() {
      gae('FORM_EDITOR', 'UPLOAD_SIGNATURE_FROM_FILE');

      Uploader.loadFromFile(
        false,
        urls => {
          getBase64FromUrl(urls[0]).then(base64 =>
            this.onReceiveSignature(base64)
          );
        },
        () => this.$f7.dialog.progress(II18.get('title_load'), 0)
      );
    }

    stopSignatureMode = () => {
      this.props.onStopSignatureProcess();
      this.setState({
        signTask: undefined,
        signPadPopupOpened: false
      });
    };

    onReceiveSignature = (data, touchData) => {
      gae('FORM_EDITOR', 'APPLY_SIGNATURE_DATA_IMAGE');

      this.props.onReceiveSignature(
        this.props.signatureProcessItem,
        data,
        touchData
      );
    };

    render() {
      const {
        document: documentItem,
        signatureProcessItem,
        cachedSignature,
        onCollectBioDataConfirmed
      } = this.props;

      let confirmCollectBioDataDialogOpened,
        signOnMobileDialogOpened,
        selectWayToSignDialogOpened,
        signPadDialogOpened,
        bioDataRequired;

      if (signatureProcessItem) {
        bioDataRequired = signatureProcessItem.collectBiometricData;
        selectWayToSignDialogOpened = !this.state.signTask?.wayToSign;
        signOnMobileDialogOpened =
          this.state.signTask?.wayToSign === WAYS_TO_SIGN.SIGN_ON_MOBILE;
        signPadDialogOpened =
          (!bioDataRequired || this.props.collectBioDataConfirmed) &&
          this.state.signTask?.wayToSign === WAYS_TO_SIGN.SIGN_ON_DESKTOP;
        confirmCollectBioDataDialogOpened =
          !this.props.collectBioDataConfirmed &&
          this.state.signTask?.wayToSign === WAYS_TO_SIGN.SIGN_ON_DESKTOP &&
          bioDataRequired;
      }
      return (
        <>
          <SelectWayToSignPopUp
            advancedSignature={bioDataRequired}
            cachedSignature={cachedSignature}
            opened={selectWayToSignDialogOpened}
            onCancel={this.stopSignatureMode}
            onDone={result => this.onSignatureWaySelected(result)}
          />

          <SignOnMobilePopUp
            collectBioData={bioDataRequired}
            opened={signOnMobileDialogOpened}
            widgetTitle={signatureProcessItem?.label || ''}
            documentName={documentItem.name}
            onClose={this.stopSignatureMode}
            onDone={(result, touchData) =>
              this.onReceiveSignature(result, touchData)
            }
          />

          <ConfirmCollectBioData
            opened={confirmCollectBioDataDialogOpened}
            onClose={() => !this.state.signTask && this.stopSignatureMode()}
            onCancel={this.stopSignatureMode}
            onConfirm={onCollectBioDataConfirmed}
          />

          <SignPadDialog
            opened={signPadDialogOpened}
            onCancel={this.stopSignatureMode}
            onClose={this.stopSignatureMode}
            documentName={documentItem.name}
            onSignatureDone={this.onReceiveSignature}
            signatureElement={signatureProcessItem}
          />

          <WrappedComponent {...this.props} />
        </>
      );
    }
  }

  withFormsCommonWrapper.propTypes = {
    document: PropTypes.object,
    signatureProcessItem: PropTypes.object,
    collectBioDataConfirmed: PropTypes.bool,
    cachedSignature: PropTypes.any,
    onReceiveSignature: PropTypes.func,
    onStopSignatureProcess: PropTypes.func,
    onCollectBioDataConfirmed: PropTypes.func
  };

  return withFormsCommonWrapper;
}
